const machines = [{
  id: `225efbd2-b994-4c60-8c80-5a3bfde9343d`,
  title: `Northgate`,
  address: `383 Spectrum Loop, Colorado Springs, CO 80921`,
  coordinates: [ 39.0241, -104.8177 ],
  taxRate: 0.0825,
}, {
  id: `f1661686-c1f2-4175-8559-6f70eff57b85`,
  title: `Briargate Crossing`,
  address: `9665 Prominent Pt, Colorado Springs, CO 80924`,
  coordinates: [ 38.9701, -104.7399 ],
  taxRate: 0.0825,
}, {
  id: `759ddb29-ea40-4fce-8de2-c6996e2c6dd1`,
  title: `LAX`,
  address: `9149 S Sepulveda Blvd, Los Angeles, CA 90045`,
  coordinates: [ 33.9537, -118.3968 ],
  taxRate: 0.095,
}].reduce((machines, machine) => {
  machines[machine.id] = machine
  return machines
}, {})

module.exports = machines
